var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.328,
    height: 23.736,
    viewBox: "0 0 77.328 23.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment_Option_1",
    "data-name": "Payment Option 1",
    transform: "translate(-1150 -361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M61.9,23.887,65.819.9h6.253L68.153,23.887Z",
    transform: "translate(1115.359 360.496)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M103.8.969A15.593,15.593,0,0,0,98.211,0C92,0,87.642,3.127,87.642,7.574c-.044,3.3,3.127,5.152,5.5,6.253,2.422,1.145,3.259,1.85,3.259,2.862,0,1.541-1.938,2.246-3.743,2.246a13.47,13.47,0,0,1-5.9-1.189l-.881-.4L85,22.5a19.788,19.788,0,0,0,7,1.233c6.605,0,10.877-3.083,10.921-7.838.044-2.6-1.629-4.624-5.24-6.253-2.2-1.057-3.523-1.761-3.523-2.862,0-.969,1.145-1.982,3.567-1.982a10.845,10.845,0,0,1,4.668.881l.572.264L103.8.969",
    transform: "translate(1102.431 361)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M142.038,1h-4.844a3.138,3.138,0,0,0-3.3,1.894L124.6,23.943h6.561s1.057-2.818,1.321-3.435H140.5c.176.793.749,3.435.749,3.435h5.813L142.038,1m-7.706,14.8c.528-1.321,2.51-6.429,2.51-6.429-.044.044.528-1.321.837-2.2l.44,1.982s1.189,5.5,1.453,6.65Z",
    transform: "translate(1080.269 360.44)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M30.357.9,24.192,16.577l-.661-3.171c-1.1-3.655-4.668-7.662-8.631-9.644l5.593,20.125h6.65L37.006.9H30.357",
    transform: "translate(1141.661 360.496)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M10.172.9H.088L0,1.384C7.883,3.278,13.079,7.9,15.237,13.406l-2.2-10.569c-.4-1.453-1.5-1.894-2.862-1.938",
    transform: "translate(1150 360.496)",
    fill: "#bce0fd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa1);
export default __webpack_public_path__ + "static/media/visa1.cae8e3aa028c1c9b581f24be6918a966.svg";
export { ForwardRef as ReactComponent };